import { HStack, VStack, Skeleton } from '@vimeo/bokeh';

export const SkeletonRow = ({ w = '100%', h = '2xs' }) => {
  return <Skeleton w={w} h={h} borderRadius="pill" bgSize="200%" />;
};

export const SkeletonCircle = ({ w = 'md', h = 'md' }) => {
  return <Skeleton w={w} h={h} borderRadius="round" bgSize="200%" />;
};

// A single comment skeleton
export const CommentSkeleton = ({ opacity = '100%' }: { opacity?: string }) => {
  return (
    <HStack px={{ base: 200, md: 300 }} py={100} align="stretch" w="100%" opacity={opacity}>
      <SkeletonCircle />
      <VStack spacing={75} flex={1} align="stretch">
        <SkeletonRow w="90%" />
        <SkeletonRow w="100%" />
        <SkeletonRow w="70%" />
      </VStack>
    </HStack>
  );
};

// A list of comment skeletons fading out
export const CommentsSkeleton = () => {
  return (
    <VStack flexGrow={1} align="stretch" spacing={75} pt={200} overflow="hidden" w="100%" h="100%">
      <CommentSkeleton opacity="100%" />
      <CommentSkeleton opacity="100%" />
      <CommentSkeleton opacity="80%" />
      <CommentSkeleton opacity="40%" />
      <CommentSkeleton opacity="20%" />
    </VStack>
  );
};
